import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <img src="/logo.png" alt="Triveni Pay" className="footer-logo-img" />
            <p className="footer-desc">
              A reliable Forex investment and trading platform dedicated to empowering individuals to achieve financial growth through knowledge-driven strategies.
            </p>
          </div>
          <div>
            <div className="footer-title">Quick Links</div>
            <ul className="footer-links">
              <li><a href="/#about">About Us</a></li>
              <li><a href="/#services">Services</a></li>
              <li><a href="/#income">Income Plan</a></li>
              <li><a href="/#terms">Terms & Conditions</a></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>
          <div>
            <div className="footer-title">Income Types</div>
            <ul className="footer-links">
              <li><a href="/#income">ROI Income (1% Daily)</a></li>
              <li><a href="/#income">Direct Income</a></li>
              <li><a href="/#income">Level Income</a></li>
              <li><a href="/#income">Royalty Income</a></li>
              <li><a href="/#income">Reward Income</a></li>
            </ul>
          </div>
          <div>
            <div className="footer-title">Join Us</div>
            <ul className="footer-links">
              <li><Link to="/register">Register Now</Link></li>
              <li><Link to="/login">Login</Link></li>
              <li><a href="mailto:support@trivenipay.com">support@trivenipay.com</a></li>
              <li><a href="https://www.trivenipay.com" target="_blank" rel="noreferrer">www.trivenipay.com</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} <span>Triveni Pay</span>. All rights reserved. | Together We Trade, Together We Grow.</p>
        </div>
      </div>
    </footer>
  );
}